import React, {useState} from 'react';
import Carousel from './carousel';
import {Link} from 'react-router-dom';
import {Box, Flex, Image, Text} from '@chakra-ui/react';
import ReactCursorPosition from "react-cursor-position";

const Item = (props) => {
    return (
        <Box>
            <Box
                display={props.tile_type === 'carousel' ? 'grid' : undefined}
                width={'100%'}
                mb={'10px'}
                minH={props.tile_type === 'carousel' ? '187px' : undefined}
            >
                {props.tile_type === 'image' &&
                    (props?.image_url ? (
                        props?.size == 'news' ?
                        <Box as={props?.link_url?.includes('http') ? 'a' : Link}
                        target={props?.link_url?.includes('http') ? '_blank' : undefined}
                        {...Object.assign(
                            props?.link_url?.includes('http')
                                ? {
                                    href: props?.link_url,
                                }
                                : {
                                    to: {pathname: props?.link_url || '/'},
                                },
                        )}>
                            <ImageWrapped props={props}/>
                        </Box> 
                        :
                        <Box >
                            <ImageWrapped props={props}/>
                        </Box>
                    ) : (
                        <Box
                            display={'flex'}
                            alignItems={'center'}
                            as={'a'}
                            target={'_blank'}
                            href={props?.link_url}
                            justifyContent={'center'}
                            flexDirection={'column'}
                            bgColor={'brand.700'}
                            width={'100%'}
                            height={(props?.img_height ? props?.img_height : '200px' )}
                        >
                            <Text
                                fontWeight={'400'}
                                fontSize={['48px', '64px']}
                                fontFamily={'Springfield'}
                                lineHeight={['48px', '74px']}
                                textAlign={'center'}
                                paddingTop={'6px'}
                                color={'white'}
                                noOfLines={1}
                            >
                                {props.title}
                            </Text>
                            <Text
                                fontWeight={'400'}
                                fontSize={['14px', '24px']}
                                lineHeight={['16px', '26px']}
                                textAlign={'center'}
                                color={'white'}
                                maxW={'500px'}
                                paddingRight={'20px'}
                                paddingLeft={'20px'}
                                dangerouslySetInnerHTML={{
                                    __html: props.subtitle,
                                }}
                            />
                        </Box>
                    ))}

                {props.tile_type === 'carousel' && (
                    <Carousel {...props} data={props.carousel_images}
                              minH={props.minH ? ['187px', '200px'] : undefined}/>
                )}
            </Box>
            {props.size == 'news' ?
            <Box as={props?.link_url?.includes('http') ? 'a' : Link}
                 target={props?.link_url?.includes('http') ? '_blank' : undefined}
                 {...Object.assign(
                     props?.link_url?.includes('http')
                         ? {
                             href: props?.link_url,
                         }
                         : {
                             to: {pathname: props?.link_url || '/'},
                         },
                 )}>
                <Text
                    fontWeight={'semibold'}
                    fontSize={'16px'}
                    lineHeight={'32px'}
                    textAlign={'center'}
                    color={'black'}
                    noOfLines={1}
                >
                    {props.size != 'news' ? props.title : 'Recent News'}
                </Text>
            </Box>
            :<Box>
                <Text
                    fontWeight={'semibold'}
                    fontSize={'16px'}
                    lineHeight={'32px'}
                    textAlign={'center'}
                    color={'black'}
                    noOfLines={1}
                >
                    {props.size != 'news' ? props.title : 'Recent News'}
                </Text>
            </Box>}
            <Box>
                <Text
                    textTransform={'uppercase'}
                    fontWeight={'semibold'}
                    fontSize={'8px'}
                    lineHeight={'16px'}
                    textAlign={'center'}
                    color={'blackAlpha.600'}
                >
                    {(props.size === 'news' ? '' : props.subtitle )}
                </Text>
            </Box>
        </Box>
    );
};

export default Item;

const ImageWrapped = ({props}) => {
    const [{x, y}, setMouseCoordinates] = useState({x: 0, y: 0});
    if (!props?.show_hover) {
        return (
            <Box height={"100%"}>
                <Image
                    width={'100%'}
                    height={props?.img_height}
                    src={props.image_url}
                    alt={`${props.title}-logo`}
                    objectFit={'cover'}
                    minH={props.minH ? '186px' : undefined}
                />
            </Box>
        )
    }
    return (
        <ReactCursorPosition
            onPositionChanged={({position: {x, y}}) => {
                setMouseCoordinates({x, y});
            }}
        >
            <Box height={"100%"}>
                <Box
                    _hover={{
                        '& #overlay': {
                            opacity: 1,
                            transition: '150ms all ease',
                            paddingBottom: '-14px',
                            // zIndex: 1
                        },
                        '&:before': {
                            content: "''",
                            position: 'absolute',
                            width: '100%',
                            left: 0,
                            height: '1px',
                            backgroundColor: 'white',
                            opacity: 0.2,
                            top: y,
                            zIndex: 9999999999,
                        },
                        '&:after': {
                            content: "''",
                            position: 'absolute',
                            height: '100%',
                            top: 0,
                            width: '1px',
                            backgroundColor: 'white',
                            opacity: 0.2,
                            left: x,
                            zIndex: 9999999999,
                        },
                    }}
                    userSelect={'none'}
                    position={'relative'}
                    top="0"
                    height={'100%'}
                    mb={'14px'}
                    minH={'186px'}
                >
                    {x > 70 && y > 40 && y < 350 && (
                        <Text
                            fontSize={'sm'}
                            letterSpacing={'-1px'}
                            lineHeight={'14px'}
                            as={'span'}
                            position={'absolute'}
                            top={y + 7}
                            left={x - 70}
                            id={'overlay'}
                            opacity={1}
                            color={'white'}
                            userSelect={'none'}
                            zIndex={9999999999}
                        >
                            Read more
                        </Text>
                    )}
                    <Box
                        id={'overlay'}
                        position={'absolute'}
                        inset={0}
                        px={'20px'}
                        py={'15px'}
                        bgColor={'brand.600'}
                        opacity={0}
                        height={props?.img_height}
                    >
                        <Flex
                            mb={'2px'}
                            fontSize={'14px'}
                            lineHeight={'3xl'}
                            textTransform={'uppercase'}
                            gap={5}
                        >
                            <Text as={'span'} textColor={'white'}>
                                {props?.company_status}
                            </Text>
                            <Text as={'span'} textColor={'white'}>
                                {props?.investment_status}
                            </Text>
                        </Flex>
                        <Text
                            mb={'2px'}
                            fontSize={'14px'}
                            lineHeight={'3xl'}
                            textAlign={'left'}
                        >
                            <Text as={'span'} textColor={'white'} noOfLines={5}>
                                {props.excerpt}
                            </Text>
                        </Text>
                    </Box>
                    <Image
                        width={'100%'}
                        height={props?.img_height}
                        src={props.image_url}
                        alt={`${props.title}-logo`}
                        objectFit={'cover'}
                        minH={props.minH ? '186px' : undefined}
                    />
                </Box>
            </Box>
        </ReactCursorPosition>
    )
}